module.exports = __webpack_public_path__ + "img/clue05_bg.a017054d.png";